if (!customElements.get("product-dot")) {
	class ProductDot extends HTMLElement {
	constructor() {
		super();
		this.updatePositionHandler = this.#updatePosition.bind(this);
	}

		connectedCallback() {
			this.panel = this.querySelector(".product-dot__panel");
			if (!this.panel) return;

			this.container =
				this.closest(".featured-products__image-wrapper") ||
				this.offsetParent ||
				this.parentElement;

			this.resizeObserver = new ResizeObserver(this.updatePositionHandler);
			this.resizeObserver.observe(this.panel);
			this.resizeObserver.observe(this);
			if (this.container) {
				this.resizeObserver.observe(this.container);
			}

			window.addEventListener("resize", this.updatePositionHandler);

			requestAnimationFrame(this.updatePositionHandler);
		}

		disconnectedCallback() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}

			window.removeEventListener("resize", this.updatePositionHandler);
		}

		#setShift(value) {
			this.style.setProperty("--product-dot-shift", `${value}px`);
		this.style.setProperty("--product-dot-arrow-shift", `${-value}px`);
		}

		#updatePosition() {
			if (!this.panel) return;

			const SAFE_MARGIN = 12;
			this.#setShift(0);

			const panelRect = this.panel.getBoundingClientRect();
			const containerRect =
				this.container?.getBoundingClientRect() ??
				this.parentElement?.getBoundingClientRect();

			if (!containerRect.width) return;

			let shift = 0;

			const overflowLeft = containerRect.left + SAFE_MARGIN - panelRect.left;
			const overflowRight = panelRect.right - (containerRect.right - SAFE_MARGIN);

			if (overflowLeft > 0) {
				shift = overflowLeft;
			} else if (overflowRight > 0) {
				shift = -overflowRight;
			}

			this.#setShift(shift);
		}
	}

	customElements.define("product-dot", ProductDot);
}

